export function ENABLE_SET(state, enable) {
    state.enable = enable;
}